import { render, staticRenderFns } from "./RefreshSetting.vue?vue&type=template&id=1f13ea48&lang=pug"
import script from "./RefreshSetting.vue?vue&type=script&lang=js"
export * from "./RefreshSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports